import React from 'react';

const Loading = ({ pastDelay }) => pastDelay ? <div>Loading...</div> : null;
export default Loading;